export default {
  error_param: '参数错误',
  loading: '加载中...',
  version: '版本',
  size: '大小',
  query_failed: '查询失败',
  for_ios: '适用于iOS设备',
  for_android: '适用于Android设备',
  install: '安装'
}
